/*
 * @Author: Claude (Updated)
 * @Date: 2025-11-11
 * @LastEditTime: 2025-12-31
 * @Description: FileUpload 统一常量定义
 */

/**
 * 文件上传类型枚举
 */
export enum FileUploadType {
  /** 图片上传 */
  IMAGE = 'image',
  /** 音频上传（支持音频和视频文件，统一以音频播放器形式预览） */
  AUDIO = 'audio',
  /** 视频上传 */
  VIDEO = 'video',
}

/**
 * 文件大小单位（统一使用 KB）
 */
export const FILE_SIZE_UNITS = {
  KB: 1024, // 1KB = 1024 bytes
  MB: 1024 * 1024, // 1MB = 1024KB
} as const;

/**
 * 默认文件大小限制（KB）
 */
export const DEFAULT_MAX_FILE_SIZE = {
  [FileUploadType.IMAGE]: 10 * 1024, // 10MB
  [FileUploadType.AUDIO]: 100 * 1024, // 100MB（支持音频和视频文件）
  // [FileUploadType.VIDEO]: 500 * 1024, // 500MB
} as const;
